
/*
 * @Author: your name
 * @Date: 2022-01-26 13:40:31
 * @LastEditTime: 2022-01-27 09:34:49
 * @LastEditors: Please set LastEditors
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: \zhijixiehui-homepage\src\pages\index\services\mapservice.ts
 */

import instance from '@/service'
import { MapData } from '../models/map'

export class MapService {
  async getMpaData () {
    const res = await instance.get('/api/v1/vipMembers')
    console.log(res)
    const data = res.data ? res.data : []
    const memberTotal = data.filter((item: any) => item.type === 'total')[0] !== undefined ? data.filter((item: any) => item.type === 'total')[0].dataList : []
    const standingDirectorUnit = data.filter((item: any) => item.type === 'STANDING_DIRECTOR')[0] !== undefined ? data.filter((item: any) => item.type === 'STANDING_DIRECTOR')[0].dataList : []
    const councilMembers = data.filter((item: any) => item.type === 'DIRECTOR')[0] !== undefined ? data.filter((item: any) => item.type === 'DIRECTOR')[0].dataList : []
    const memberUnit = data.filter((item: any) => item.type === 'MEMBER')[0] !== undefined ? data.filter((item: any) => item.type === 'MEMBER')[0].dataList : []
    return new MapData(memberTotal, standingDirectorUnit, councilMembers, memberUnit)
  }

  async getProvinceData (name: string) {
    const res = await instance.get(`/api/v1/vipMember/detail?regionName=${name}`)
    console.log(res)
    const data = res.data ? res.data : []
    return data
  }
}
